export const LOGO_URL = "/logo-recetrans.png";
